import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import { Box } from '../Box/Box';
import { useFetchNextPage, useResizeOnScreenSizeChange } from './hooks';
export const InfinityList = ({ getLoaderRow, getRow, isLoading, rows, hasNextPage, getRowHeight, fetchNextPage, isFetching, height, minHeight, gap, screenSize, numberOfLoaderRows = 10, overscan = 5, }) => {
    const parentRef = useRef(null);
    const rowVirtualizer = useVirtualizer({
        count: hasNextPage ? rows.length + 1 : rows.length,
        getScrollElement: () => parentRef.current,
        estimateSize: getRowHeight,
        overscan: overscan,
        gap,
    });
    useFetchNextPage({
        fetchNextPage,
        hasNextPage,
        isFetching,
        rows,
        rowVirtualizer,
        triggerBottomRowIndex: overscan,
    });
    useResizeOnScreenSizeChange({ rowVirtualizer, screenSize });
    return (_jsx("div", { ref: parentRef, style: {
            height,
            minHeight,
            overflow: 'auto',
            transform: 'translateZ(0)',
        }, children: _jsxs("div", { style: {
                height: `${rowVirtualizer.getTotalSize()}px`,
                position: 'relative',
            }, children: [isLoading && (_jsx(Box, { display: 'flex', flexDirection: 'column', style: { gap, height: getRowHeight() }, children: new Array(numberOfLoaderRows).fill(null).map((_, index) => getLoaderRow(index)) })), rowVirtualizer.getVirtualItems().map((virtualRow, index) => {
                    const isLoaderRow = virtualRow.index > rows.length - 1;
                    const data = rows[virtualRow.index];
                    return (_jsx("div", { style: {
                            position: 'absolute',
                            top: 0,
                            zIndex: rows.length - virtualRow.index,
                            left: 0,
                            width: '100%',
                            height: `${virtualRow.size}px`,
                            transform: `translateY(${virtualRow.start}px)`,
                        }, children: isLoaderRow ? getLoaderRow(virtualRow.index) : getRow({ data, index }) }, virtualRow.index));
                })] }) }));
};
